<template>
  <div>
    <CardWrapper
      :is-loading="perronPreloader"
      :hasAccess="1"
    >
      <template #title>
        КАРТА ПЕРРОНА
      </template>
      <template #icon>
        <PerronIcon/>
      </template>

        <v-card-title class="perron-error" v-if="perron.length == 0 && !perronPreloader">Отсутствуют данные по географическим координатам стоянок</v-card-title>

        <div style="height: 245px" v-else>
          <vl-map
            :load-tiles-while-animating="true"
            :load-tiles-while-interacting="true"
            data-projection="EPSG:4326"
            class="h-100"
            @click="clickHandler"
          >
            <vl-view
              v-if="perron.length > 0"
              :zoom.sync="zoom"
              :min-zoom="Number(13)"
              :max-zoom="Number(19)"
              :center="center"
              :rotation.sync="rotation"
            ></vl-view>
            <vl-feature
              :id="'stand-' + index"
              v-for="(stand, index) in perron"
              :key="'stand-' + index"
            >
              <vl-geom-polygon
                :coordinates="[getPolygon(parseFloat(stand.LON_Coord), parseFloat(stand.LAT_Coord), geomObjects.stand, 0.00005)]"
              ></vl-geom-polygon>
              <vl-style-box>
                <vl-style-stroke color="red"></vl-style-stroke>
                <vl-style-fill :color="[255, 87, 34, 0.2]"></vl-style-fill>
              </vl-style-box>
              <vl-overlay
                v-if="selectedStopId === index"
                :auto-pan="true"
                :auto-pan-animation="{ duration: 300 }"
                :auto-pan-margin="10"
                :position="[parseFloat(stand.LON_Coord), parseFloat(parseFloat(stand.LAT_Coord))]"
                style="z-index: 99999 !important"
                :offset="[-5, -30]"
                positioning="bottom-left"
              >
                <bortInfo :bort="stand"></bortInfo>
              </vl-overlay>
            </vl-feature>

            <vl-layer-tile>
              <vl-source-xyz :url="url"></vl-source-xyz>
            </vl-layer-tile>

            <div v-if="perron.length > 0">
              <vl-overlay
                :id="'stand-' + index"
                v-for="(stand, index) in perron"
                :key="'stand-' + index"
                :position="[parseFloat(stand.LON_Coord), parseFloat(stand.LAT_Coord)]"
              >
                <template slot-scope="scope">
                  <div class="overlay-content row">
                    <div
                      class="plane-icon"
                      v-if="stand.isStandActive"
                      @click.capture="selectStopHandler(index)"
                    >
                      <img
                        v-if="stand.FlightInfo.IsHell == 1"
                        :width="`${widthPlaneImage}px`"
                        src="/static/img/plane-icons/helicopter.png"
                        alt
                      />
                      <img
                        v-else-if="stand.FlightInfo.MTOW > 130000"
                        :width="`${widthPlaneImage}px`"
                        src="/static/img/plane-icons/large.png"
                        alt
                      />
                      <img
                        v-else-if="stand.FlightInfo.MTOW >= 30000"
                        :width="`${widthPlaneImage}px`"
                        src="/static/img/plane-icons/medium.png"
                        alt
                      />
                      <img
                        v-else
                        :width="`${widthPlaneImage}px`"
                        src="/static/img/plane-icons/small.png"
                        alt
                      />
                    </div>
                    <div v-else>
                      <div class="plane-icon">
                        {{ stand.Name }}
                      </div>
                    </div>
                  </div>
                </template>
              </vl-overlay>
            </div>
          </vl-map>
        </div>
    </CardWrapper>
  </div>
</template>

<script>
import store from '@/store'
import geomObjects from '@/geom-objects'
import objectInfo from './objectInfo.vue'
import bortInfo from './bortInfo.vue'
import CardWrapper from "../ui/CardWrapper.vue";
import MonitoringIcon from "../ui/icons/MonitoringIcon.vue";
import PerronIcon from "../ui/icons/PerronIcon.vue";

export default {
  components: {PerronIcon, MonitoringIcon, CardWrapper, bortInfo, objectInfo },
  data() {
    return {
      url: 'https://mt.google.com/vt/lyrs=m&hl=ru&x={x}&y={y}&z={z}',
      zoom: 16,
      rotation: 0,
      geomObjects: geomObjects.objects,
      selectedStopId: null
    }
  },
  computed: {
    center() {
      return [parseFloat(this.perron[0].LON_Coord), parseFloat(this.perron[0].LAT_Coord)]
    },
    widthPlaneImage: {
      get() {
        switch (this.zoom) {
          case 13:
            return 3
          case 14:
            return 6
          case 15:
            return 12
          case 16:
            return 24
          case 17:
            return 44
          case 18:
            return 80
          case 19:
            return 145
        }
      },
    },
    airportPosition: {
      get() {
        return store.getters['getAirportPosition']
      },
    },
    perron: {
      get() {
        let perronObjects = store.getters['maps/getSmallPerronObjects']

        let result = perronObjects.map(function(object) {
          object.LAT_Coord = parseFloat(object.LAT_Coord.toString().replace(/,/g, '.'))
          object.LON_Coord = parseFloat(object.LON_Coord.toString().replace(/,/g, '.'))
          return object
        })

        return result
      },
    },
    perronPreloader: {
      get() {
        return store.getters['maps/getSmallPerronPreloader']
      },
    },
  },
  methods: {
    getPolygon: geomObjects.methods.getPolygon,
    selectStopHandler(id) {
      this.selectedStopId = id
    },
    clickHandler() {
      this.selectedStopId = null
    }
  },

}
</script>
